// /api/modulePosts.js
import api from "@/utils/axios";

// GET all module posts
export const getAllModulePosts = (params = {}) => api.get("/api/module-posts", { params });

// GET module post by ID
export const getModulePostById = (id, params = {}) => api.get(`/api/module-posts/${id}`, { params });

// CREATE a new module post
export const createModulePost = (payload) => {
    const config = payload instanceof FormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};

    return api.post("/api/module-posts", payload, config);
};

// UPDATE a module post by ID
export const updateModulePost = (id, payload) => {
    const config = payload instanceof FormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};

    return api.put(`/api/module-posts/${id}`, payload, config);
};
// DELETE a module post by ID
export const deleteModulePost = (id) => api.delete(`/api/module-posts/${id}`);
